import { Colors } from './colors'
export function muiCssBaseline(colors: Colors) {
  return {
    styleOverrides: `
      .lgShow {
        display: block !important;
      }
      .lgShowNo {
        display: block !important;
      }
      @media (max-width: 1200px) {
        html {
          min-width: unset !important;
          // font-size: 0.8vw !important;
        }
      }
      /* 992px */
      @media (max-width: 900px) {
        html {
          min-width: unset !important;
          // font-size: 2.8vw !important;
        }
        body {
          font-weight: 400;
          line-height: unset;
        }
        .flexColumnReverseCenterCenter {
          display: flex;
          flex-direction: column-reverse;
          align-items:center;
          justify-content: center;
        }
        .col-sm-12 {
          grid-area: auto/auto/auto/span 12 !important;
        }
        .smShow {
          display: block !important;
        }
        .smShowNo {
          display: none !important;
        }
        .smFlexColumnStartCenter {
          display: flex;
          flex-direction: column;
          align-items: flex-start;
          justify-content: center;
        }
        #basic-menu-mobile .accordionWrap {
          width: 100%;
        }
      }
      * {
        box-sizing: border-box;
        margin: 0;
        padding: 0;
      }
      input::-webkit-autofill {
        -webkit-box-shadow: 0 0 0px 1000px #121212 inset !important;
        -webkit-text-fill-color: white !important;
      }
      html {
        font-size: 16px;
        @madia (max-width: 900px) {
          font-size: 12px;
        }
      }
      body {
        background: ${colors.background.article};
        font-family: 'Roboto', 'Roboto Condensed', sans-serif;
        font-style: normal;
        overflow-x: hidden;
        color: ${colors.white};
        padding: 0 !important;
      }
      iframe {
        display: none;
      }
      #root {
        position: relative;
      }
      a {
        text-decoration: none;
        color: ${colors.neutral[900]};
      }
      h1 {
        font-family: 'Roboto', 'Roboto Condensed', sans-serif;
      }
      textarea {
        font-family: 'Roboto', 'Roboto Condensed', sans-serif;
        background: transparent;
        border: 0;
        resize: none;
        outline: none;
        font-size: 1rem;
        line-height: 24px;
        width: 100%;
        border: 2px solid ${colors.neutral[500]};
        padding: 24px;
        color: ${colors.white};
        ::placeholder {
          color: ${colors.neutral[500]};
        }
      }
      .mobile-header-popover {
        z-index: 900 !important;
        .MuiBackdrop-root {
          background: transparent !important;
        }
        .MuiPaper-root {
          top: 56px !important;
          left: 0 !important;
          max-width: 100vw !important;
        }
      }
      .MuiTouchRipple-root {
        display: none;
      }
      .primary-header {
        background: #000 !important;
      }
      .table-sticky {
        position: sticky;
        right: 0;
        &::after {
          position: absolute;
          top: 0;
          bottom: -1px;
          left: 0;
          width: 30px;
          transform: translate(-100%);
          transition: box-shadow 0.3s;
          content: '';
          pointer-events: none;
          box-shadow: inset -10px 0 8px -8px #00000026;
        }
      }
      .Toastify {
        z-index: 999999999;
        .Toastify__toast-container {
          width: 460px;
          top: 78px;
        }
        @media (max-width: 900px) {
          .Toastify__toast-container {
            width: 100vw !important;
          }
        }
        .Toastify__toast {
          border: 1px solid #161616;
          box-shadow: -10px 0px 40px rgba(0, 0, 0, 0.4);
          padding: 24px;
          border-radius: 0;
          .error, .success, .info {
            width: 28px;
            margin-right: 26px;
          }
          .toast-close {
            width: 28px;
          }
        }
        .Toastify__toast-icon {
          width: 28px;
          margin-right: 26px;
          svg {
            width: 28px;
            height: 28px;
            background: #fff;
            border-radius: 50%;
          }
        }
        .Toastify__toast-body {
          padding: 0 30px 0 0;
          font-weight: 600;
          font-size: 20px;
          line-height: 24px;
          display: flex;
          align-items: center;
          letter-spacing: 0.02em;
          color: #FFFFFF;
        }
        .Toastify__toast--error {
          background: linear-gradient(90deg, rgba(255, 0, 0, 0.1) 0%, rgba(36, 36, 36, 0) 100%), rgba(32, 32, 32, 0.97);
          .success {
            display: none;
          }
          .info {
            display: none;
          }
        }
        .Toastify__toast--success {
          background: linear-gradient(90deg, rgba(0, 255, 0, 0.1) 0%, rgba(36, 36, 36, 0) 100%), rgba(32, 32, 32, 0.97);
          .error {
            display: none;
          }
          .info {
            display: none;
          }
        }
        .Toastify__toast--info {
          background: linear-gradient(90deg, rgba(252, 146, 21, 0.1) 0%, rgba(36, 36, 36, 0) 100%), rgba(32, 32, 32, 0.97);
          .success {
            display: none;
          }
          .error {
            display: none;
          }
        }
      }
      .carousel .thumb, .carousel .thumb.selected, .carousel .thumb:hover, .thumb:focus {
        border-width: 0 !important;
        opacity: 1;
        width: 173px !important;
        @media (max-width: 1200px) {
          width: 128px !important;
        }
        @media (max-width: 900px) {
          width: 9.6rem !important;
        }
      }
      .carousel .slider-wrapper.axis-horizontal .slider .slide > div {
        height: 100%;
      }
      .MuiInputBase-root.Mui-error {
        border: 2px solid #FF1919!important;
      }
      .carousel .thumb {
        margin-top: 24px;
        opacity: 0.8;
        border-radius: 0;
        overflow: hidden;
        cursor: pointer;
        border: none !important;
        padding: 0 !important;
        img {
          border-radius: 0;
          width: 100%;
          height: 100%;
        }
        video {
          border-radius: 0;
        }
        @media (max-width: 1200px) {
          margin-top: 16px;
        }
      }

      .carousel .thumb:not(:last-child) {
        margin-right: 20px;
      }
      .carousel .thumbs {
        transform: none !important;
        width: 100%;
        overflow-x: auto;
        @media (max-width: 900px) {
          margin-left: 24px;
        }
      }
      .thumbs-wrapper {
        button {
          display: none;
        }
      }
      .carousel .thumbs-wrapper {
        // position: absolute;
        // bottom: 0;
        margin: 0;
        display: flex;
        justify-content: start;
      }
      .MuiTypography-gutterBottom {
        margin-bottom: 1.25rem !important;
      }
      
      .input-ph-r {
        input[type="number"] {
          -moz-appearance: textfield;
        }
        input {
          padding-right: 8px;
          text-align: right;
          font-weight: 600;
          &::placeholder {
            text-align: right;
            color: rgba(255, 255, 255, 0.2)
          },
          &::-webkit-outer-spin-button,
          &::-webkit-inner-spin-button {
            -webkit-appearance: none;
          }
        },
      },
      .igo-icon-gap {
        margin-right: 8px;
      }
      .nft-drawer {
        .MuiDrawer-paper {
          // width: 467px;
        }
      }
      .inset-html {
        word-break: break-word;
        ul, ol {
          padding-left: 20px;
        }
        pre, code {
          white-space: pre-wrap;
        }
        img {
          max-width: 100%;
        }
        video {
          max-width: 100%;
          height: auto;
        }
      }
      img[src=""], img:not([src]){
        opacity: 0;
        border:none;
        visibility: hidden;
        max-width: none;
      }
      .width-0 {
        width: 0 !important;
        overflow: hidden;
        transition: width 250ms;
        -webkit-transform: width 250ms ease-out;
      }
      .width-100 {
        transition: width 250ms;
        -webkit-transform: width 250ms ease-in;
  
      }
      .instant-deposit-modal {
        .MuiPaper-root {
          width: 480px;
          border-radius: 0;
          .MuiDialogTitle-root {
            padding: 32px;
            font-size: 32px;
            line-height: 36px;
          }
          .close-icon {
            width: 24px;
          }
        }
      }

      @media screen and (max-width: 1239.98px) {
        .article-inner {
          .article-right {
            width: 280px !important;
          }
          .article-left {
            width: calc(100% - 280px) !important;
          }
        }
      }

      @media screen and (max-width: 1079.98px) {
        .article-inner {
          .article-right {
            display: none;
          }
          .article-left {
            flex: 1 1 auto !important;
          }
        }
      }

    
      @keyframes spinLoading {
        0%{ -webkit-transform: rotate(0deg); tranform: rotate(0deg);}
        100%{ -webkit-transform: rotate(360deg); tranform: rotate(360deg);}
      }

      .public-DraftEditorPlaceholder {
        &-inner {
          color: #454545;
          font-size: 20px;
          line-height: 28px;
        }
        &-root {
          position: absolute;
          z-index: 0;
        }
      }
      .inset-html, .DraftEditor-root {
        font-size: 20px;
        line-height: 36px;
        iframe {
          display: block;
          width: 100%;
          height: 424px;
        }
        figure {
          img, video {
            width: 100%;
          }
          hr {
            border-width: 1px 0 0 0;
            width: 160px;
            border-color: #565656 transparent transparent transparent;
            margin: 0 auto;
            height: 0px;
            border-style: solid;
          }
        }
        a {
          text-decoration: underline;
          color: #797979;
          color: #7569D1;
        }
      }
      .DraftEditor-editorContainer {
        position: relative;
        z-index: 1;
        margin-top: 182px;
      }
      .fass-modal {
        .MuiDialogTitle-root {
          background: #000000;
          display: none;
        }
        .close-icon {
          width: 44px;
          height: 44px;
          padding: 8.6px;
          background-size: 25px;
          top: 0;
          right: 0;
          background-position: center;
        }
        .MuiPaper-root {
          background: #000000;
          box-shadow: 0px 0px 40px rgba(0, 0, 0, 0.2);
        }
      }
      .edit-modal {
        .MuiDialogTitle-root {
          background: unset;
        }
        .MuiPaper-root {
          background: linear-gradient(180deg, #202020 0%, #161616 100%);
        }
      }
      blockquote {
        border-left: 4px solid #aaaaaa;
        padding-left: 12px;
        color: #797979;
      }
      .public-DraftStyleDefault-unorderedListItem {
        margin-left: 24px;
      }
      #editor-upload-image, #editor-upload-video, #editor-upload-cover {
        display: none;
      }
    `,
  }
}
